// extracted by mini-css-extract-plugin
export default {"options":"list_options__FrZMC","option_delete_button":"list_option_delete_button__m0YPc"};